import { render, staticRenderFns } from "./quiz-tips.vue?vue&type=template&id=2d894f9c"
import script from "./quiz-tips.vue?vue&type=script&lang=js"
export * from "./quiz-tips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports